export default {"src":"/_next/static/media/prag-logo-light.a246bacd.svg","height":91,"width":240,"blurWidth":0,"blurHeight":0};